import {
    mdiCheckCircleOutline,
    mdiFlashOutline,
    mdiHelpCircleOutline,
    mdiHospitalBuilding,
    mdiMedicalBag,
    mdiThermometer,
} from '@mdi/js';
import _ from 'lodash';
import React from 'react';
import { ClaimResponsibilityType } from '../../api';
import * as S from './claim-responsibility-status.styles';

export interface IClaimResponsibilityStatusProps {
    className?: string;
    responsibility?: ClaimResponsibilityType;
}

const responsibilityIcons: Record<ClaimResponsibilityType, string> = {
    [ClaimResponsibilityType.ENTER]: mdiFlashOutline,
    [ClaimResponsibilityType.PAYER]: mdiHospitalBuilding,
    [ClaimResponsibilityType.PROVIDER]: mdiMedicalBag,
    [ClaimResponsibilityType.GUARANTOR]: mdiThermometer,
    [ClaimResponsibilityType.NONE]: mdiCheckCircleOutline,
    [ClaimResponsibilityType.UNKNOWN]: mdiHelpCircleOutline,
};

const getResponsibilityLabel = (responsibility?: ClaimResponsibilityType): string => {
    if (!responsibility) {
        return 'Unknown';
    }

    return _.startCase(responsibility.toLowerCase());
};

export const ClaimResponsibilityStatus: React.FC<IClaimResponsibilityStatusProps> = ({ className, responsibility }) => {
    const resolvedResponsibility = responsibility ?? ClaimResponsibilityType.UNKNOWN;
    const label = getResponsibilityLabel(responsibility);
    const icon = responsibilityIcons[resolvedResponsibility];

    return (
        <S.Status className={className} responsibility={resolvedResponsibility}>
            {label}
            <S.StatusIcon path={icon} size="14px" />
        </S.Status>
    );
};
